import { cropRecipeTitle } from "@/utils/rezeptAPI/helper";
import styles from "./RecipeCard.module.scss";

type CardTitleProps = {
  htmlTag: 3 | 4;
  title: string;
};

export const CardTitle = ({ htmlTag, title }: CardTitleProps) => {
  return (
    <div className={styles["card-title-wrapper"]}>
      <span role="heading" aria-level={htmlTag} className={`recipe-card-title`}>
        {cropRecipeTitle(title)}
      </span>
    </div>
  );
};
